<template>
  <button
    type="button"
    @click="onClick"
    class="btn text-xs py-1 px-3 bg-gray-200 border border-gray-400 w-20"
  >
    {{ label }}
  </button>
</template>

<script setup>
import { computed } from 'vue'
import spaceMovementPanel from '@/Pages/Packages/SpaceMovementPanel'
import spaceManagement from '@/Pages/Packages/SpaceManagement'

/**
 * @typedef {Object} SpaceCellParams
 * @property {Number} locationId
 * @property {Number} spaceId
 * @property {Object} data
 */
const props = defineProps({
  /** @type {SpaceCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const onClick = () => {
  spaceManagement.initForm({
    locationId: props.params.locationId,
    spaceId: props.params.spaceId,
    subLotId: props.params.data.sub_lot_num
  })
  spaceMovementPanel.open()
}

const label = computed(() => {
  if (props.params.showOnHand) {
    return (
      (props.params.data.space_qtys_on_hand[props.params.spaceId] || 0) +
      ' | ' +
      (props.params.data.space_qtys[props.params.spaceId] || 0)
    )
  }

  return props.params.data.space_qtys[props.params.spaceId] || 0
})
</script>
